module.exports = __webpack_public_path__ + "static/media/condominium-large.2aadba7a.webp";